// =====================================================
// InstallSignal  (Refer & Earn — CONDITION 1)
//
// A render-less component that activates the install-signal reporter. Mounted
// once in App.js beside <ActivityTracker/>, whose pattern it deliberately
// copies: it renders nothing, adds no DOM and no-ops until the user is
// authenticated.
//
// It exists so useInstallSignal can run app-wide from a single place rather
// than being wired into every screen — and, importantly, so that reporting the
// install is completely independent of the Install BUTTON. InstallButton.js
// keeps its own behaviour (shown in a browser, hidden once installed) exactly
// as it is; this only listens for the signals the browser already emits.
// =====================================================

import useInstallSignal from "../../hooks/useInstallSignal";

export default function InstallSignal() {
  useInstallSignal();
  return null;
}
